/**
 * Creates a validation function that checks a `string` value matches the provided `RegExp` format.
 * @param format The format that the value must match.
 */
export const validateFormat = (format) => {
    return (value, logger, logLabel) => {
        const valid = format === undefined || format.test(value);
        if (!valid)
            logger(`${logLabel} does not match the allowed format: ${format}.`);
        return valid;
    };
};
//# sourceMappingURL=format.js.map